import {
  Button,
  Card,
  Col,
  Form,
  Input,
  Row,
  Table,
  TimePicker,
  Typography,
} from "antd";

import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import React, { Fragment, useEffect, useState } from "react";
import { CSVLink } from "react-csv";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  addShift,
  loadAllShift,
} from "../../redux/rtk/features/shift/shiftSlice";
import ViewBtn from "../Buttons/ViewBtn";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";
import ColVisibilityDropdown from "../Shared/ColVisibilityDropdown";
import { CsvLinkBtn } from "../UI/CsvLinkBtn";

dayjs.extend(utc);
dayjs.extend(timezone);

function CustomTable({ list }) {
  const [columnsToShow, setColumnsToShow] = useState([]);

  const columns = [
    {
      id: 1,
      title: "S.No",
      dataIndex: "serial",
      key: "serial",
    },
    {
      id: 2,
      title: "Name",
      dataIndex: "name",
      key: "name",
    },

    {
      id: 3,
      title: "Start Time",
      dataIndex: "startTime",
      key: "startTime",
      render: (startTime) => dayjs(startTime).utc().format(" hh:mm A"),
    },

    {
      id: 4,
      title: "End Time",
      dataIndex: "endTime",
      key: "endTime",
      render: (endTime) => dayjs(endTime).utc().format(" hh:mm A"),
    },
    {
      id: 5,
      title: "Action",
      dataIndex: "id",
      key: "action",
      render: (id) => <ViewBtn path={`/admin/shift/${id}/`} />,
    },
  ];

  useEffect(() => {
    setColumnsToShow(columns);
  }, []);

  const columnsToShowHandler = (val) => {
    setColumnsToShow(val);
  };

  // const addKeys = (arr) => arr.map((i) => ({ ...i, key: i.id }));
  const addKeys = (arr) =>
    arr.map((i, index) => ({ ...i, key: i.id, serial: index + 1 }));

  return (
    <Card>
      <div className="text-center my-2 flex justify-between">
        <h5 className="department-list-title text-color-2 text-xl mb-2">
          Shift List
        </h5>
        {list && (
          <div>
            <CsvLinkBtn>
              <CSVLink
                data={list}
                className="btn btn-dark btn-sm mb-1"
                filename="shift"
              >
                Download CSV
              </CSVLink>
            </CsvLinkBtn>
          </div>
        )}
      </div>

      {list && (
        <div style={{ marginBottom: "30px" }}>
          <ColVisibilityDropdown
            options={columns}
            columns={columns}
            columnsToShowHandler={columnsToShowHandler}
          />
        </div>
      )}

      <Table
        scroll={{ x: true }}
        loading={!list}
        columns={columnsToShow}
        dataSource={list ? addKeys(list) : []}
      />
    </Card>
  );
}

const AddShift = ({ drawer }) => {
  const [loader, setLoader] = useState(false);
  const shift = useSelector((state) => state.shift.list);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadAllShift());
  }, []);

  const { Title } = Typography;
  const [form] = Form.useForm();

  const onFinish = async (values) => {
	const shiftData = {
	  name: values.name,
	  startTime: dayjs(values.startTime).format("HH:mm:ss"), // Should output "13:00:00"
	  endTime: dayjs(values.endTime).format("HH:mm:ss"), // Should output "19:00:00"
	};
  
	console.log("Sending shift data:", shiftData); // Debug log
  
	setLoader(true);
	const resp = await dispatch(addShift(shiftData));
  
	if (resp.payload.message === "success") {
	  setLoader(false);
	  form.resetFields();
	  dispatch(loadAllShift());
	} else {
	  setLoader(false);
	}
  };

  const onFinishFailed = (errorInfo) => {
    toast.warning("Failed at adding shift");
    setLoader(false);
  };
  return (
    <UserPrivateComponent permission={"create-shift"}>
      <Row
        className="mr-top"
        gutter={[16, 16]}
        justify="space-between"
        align="top"
      >
        {/* Form Column */}
        <Col
          xs={24}
          sm={24}
          md={12}
          lg={8}
          xl={8}
          className="column-design border rounded card-custom"
          style={{ minHeight: "auto", padding: "20px" }}
        >
          <Title level={4} className="m-2 mt-5 mb-5 text-center">
            Add Shift
          </Title>
          <Form
            form={form}
            name="basic"
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 12 }}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
          >
            <Form.Item
              label="Name"
              name="name"
              rules={[{ required: true, message: "Please input your shift!" }]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              label="Start Time"
              name="startTime"
              rules={[{ required: true, message: "Please input start time!" }]}
            >
              <TimePicker format="HH:mm:ss" />
            </Form.Item>

            <Form.Item
              label="End Time"
              name="endTime"
              rules={[{ required: true, message: "Please input end time!" }]}
            >
              <TimePicker format="HH:mm:ss" />
            </Form.Item>

            <Form.Item wrapperCol={{ offset: 6, span: 12 }}>
              <Button
                onClick={() => setLoader(true)}
                type="primary"
                size="large"
                htmlType="submit"
                block
                loading={loader}
              >
                Add New Shift
              </Button>
            </Form.Item>
          </Form>
        </Col>

        {/* Table Column */}
        <UserPrivateComponent permission={"readAll-shift"}>
          <Col xs={24} sm={24} md={12} lg={16} xl={16}>
            {drawer || <CustomTable list={shift} />}
          </Col>
        </UserPrivateComponent>
      </Row>
    </UserPrivateComponent>
  );
};

export default AddShift;
